import { FormInstance } from "antd/es/form";
import { Guid } from "guid-typescript";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ITalepDetay_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ITalepDetay_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  DealerContextByKuserId: any[];
  DealerContextByKuserId_dummy: any[];
  IssuesById: any[];
  IssuesById_dummy: any[];
  IssueDocumentsByIssueId: any[];
  IssueDocumentsByIssueId_dummy: any[];
  SelectIssueMessagesForChat: any[];
  SelectIssueMessagesForChat_dummy: any[];
  UpdateIssueMessagesIsRead: number;
  UpdateIssueMessagesIsRead_dummy: number;
  SelectIssueImages: any[];
  SelectIssueImages_dummy: any[];
  IssueDocumentsCount: any[];
  IssueDocumentsCount_dummy: any[];
  IssuesImageCount: any[];
  IssuesImageCount_dummy: any[];
  IsReadUpdate: number;
  IsReadUpdate_dummy: number;
  IssueStatuUpdate: number;
  IssueStatuUpdate_dummy: number;
  OpenInBrowser: any;
  OpenInBrowser_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  ToggleVisibilityOf: string;
  ToggleVisibilityOf_dummy: string;
  SelectIssuesDocumentsBase64ById: any[];
  SelectIssuesDocumentsBase64ById_dummy: any[];
  DownloadFile: any;
  DownloadFile_dummy: any;
  isWeb: boolean;
  isWeb_dummy: boolean;
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  IssuesImageSave: number;
  IssuesImageSave_dummy: number;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  IssueMessagesSave: number;
  IssueMessagesSave_dummy: number;
  isComp113390Visible: "visible" | "hidden";
  isComp198191Visible: "visible" | "hidden";
  isComp24762Visible: "visible" | "hidden";
  isComp287898Visible: "visible" | "hidden";
  isComp16524Visible: "visible" | "hidden";
  isComp971495Visible: "visible" | "hidden";
  isComp536259Visible: "visible" | "hidden";
  isComp674625Visible: "visible" | "hidden";
  isComp913467Visible: "visible" | "hidden";
}

export class TalepDetay_ScreenBase extends React.PureComponent<
  ITalepDetay_ScreenProps,
  any
> {
  talepdetay_674625_value_kuikaSelectBoxRef: React.RefObject<any>;
  talepdetay_62971_value_kuikaFlexGridRef: React.RefObject<any>;
  talepdetay_924396_value_kuikaFlexGridRef: React.RefObject<any>;
  talepdetay_623970_value_kuikaChatRef: React.RefObject<any>;
  ml = [
    {
      Id: "f6e17cbf-9877-1e37-1dda-7f0e2f0194a4",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "58f12691-42c0-4569-8d3d-7de148711af0",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "a51344d4-0663-423c-8b8b-2b521317000c",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 49035, PropertyName: "value", Value: "Talep Detay" },
        { Id: 674625, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 85315, PropertyName: "value", Value: "Yüklenen Belgeler" },
        {
          Id: 62971,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 373111, PropertyName: "value", Value: "[datafield:createdat]" },
        { Id: 145503, PropertyName: "value", Value: "Yüklenen Görseller" },
        {
          Id: 924396,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.talepdetay_674625_value_kuikaSelectBoxRef = React.createRef();
    this.talepdetay_62971_value_kuikaFlexGridRef = React.createRef();
    this.talepdetay_924396_value_kuikaFlexGridRef = React.createRef();
    this.talepdetay_623970_value_kuikaChatRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      DealerContextByKuserId: [],
      IssuesById: [],
      IssueDocumentsByIssueId: [],
      SelectIssueMessagesForChat: [],
      UpdateIssueMessagesIsRead: 0,
      SelectIssueImages: [],
      IssueDocumentsCount: [],
      IssuesImageCount: [],
      IsReadUpdate: 0,
      IssueStatuUpdate: 0,
      OpenInBrowser: "",
      NAVIGATE: "",
      ToggleVisibilityOf: "",
      SelectIssuesDocumentsBase64ById: [],
      DownloadFile: "",
      isWeb: false,
      IfThenElse: false,
      IssueMessagesSave: 0,
      dataSource_674625: [
        { key: "Beklemede", text: "Beklemede" },
        { key: "IslemeAlindi", text: "İşleme Alındı" },
        { key: "Tamamlandı", text: "Tamamlandı" },
      ],
      isComp113390Visible: "hidden",
      isComp198191Visible: "hidden",
      isComp24762Visible: "visible",
      isComp287898Visible: "hidden",
      isComp16524Visible: "hidden",
      isComp971495Visible: "visible",
      isComp536259Visible: "hidden",
      isComp674625Visible: "hidden",
      isComp913467Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("talepdetay", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.TalepDetayPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("talepdetay", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("talepdetay", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.TalepDetayPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      talepdetay_426509_value:
        this.state.IssuesById?.at?.(0)?.imageURL ?? undefined,
      talepdetay_674625_value:
        this.state.IssuesById?.at?.(0)?.status ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  TalepDetayPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      KuserID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      Id_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
      IssueID_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
      IssueID_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
      IssueID_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
      IssuesId_5: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
      IssueID_6: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
      IssueID_7: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
      IssueID_8: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
      DealerID_8: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.DealerContextByKuserId !== undefined
            ? stateVars.DealerContextByKuserId?.length > 0
              ? stateVars.DealerContextByKuserId[0].id
              : null
            : this.state.DealerContextByKuserId?.length > 0
            ? this.state.DealerContextByKuserId[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TalepDetay/TalepDetayPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.DealerContextByKuserId = result?.data.dealerContextByKuserId;
    stateVars.isComp536259Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.IssuesById !== undefined
            ? stateVars.IssuesById?.length > 0
              ? stateVars.IssuesById[0].assignedTo
              : null
            : this.state.IssuesById?.length > 0
            ? this.state.IssuesById[0].assignedTo
            : null
        ),
        ReactSystemFunctions.toString(
          this,
          stateVars.DealerContextByKuserId !== undefined
            ? stateVars.DealerContextByKuserId?.length > 0
              ? stateVars.DealerContextByKuserId[0].id
              : null
            : this.state.DealerContextByKuserId?.length > 0
            ? this.state.DealerContextByKuserId[0].id
            : null
        )
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp674625Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.DealerContextByKuserId !== undefined
            ? stateVars.DealerContextByKuserId?.length > 0
              ? stateVars.DealerContextByKuserId[0].id
              : null
            : this.state.DealerContextByKuserId?.length > 0
            ? this.state.DealerContextByKuserId[0].id
            : null
        ),
        ReactSystemFunctions.toGuid(
          this,
          stateVars.IssuesById !== undefined
            ? stateVars.IssuesById?.length > 0
              ? stateVars.IssuesById[0].assignedTo
              : null
            : this.state.IssuesById?.length > 0
            ? this.state.IssuesById[0].assignedTo
            : null
        )
      ) === true
        ? "visible"
        : "hidden";
    stateVars.IssuesById = result?.data.issuesById;
    formVars.talepdetay_426509_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].imageURL
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].imageURL
        : null
    );
    formVars.talepdetay_536259_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].statuString
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].statuString
        : null
    );
    formVars.talepdetay_674625_value =
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].status
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].status
        : null;
    formVars.talepdetay_630431_value = ReactSystemFunctions.value(
      this,
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].createdAt
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].createdAt
        : null
    );
    formVars.talepdetay_11419_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].title
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].title
        : null
    );
    formVars.talepdetay_583778_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].content
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].content
        : null
    );
    formVars.talepdetay_913467_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].externalLink
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].externalLink
        : null
    );
    stateVars.isComp536259Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.IssuesById !== undefined
            ? stateVars.IssuesById?.length > 0
              ? stateVars.IssuesById[0].assignedTo
              : null
            : this.state.IssuesById?.length > 0
            ? this.state.IssuesById[0].assignedTo
            : null
        ),
        ReactSystemFunctions.toString(
          this,
          stateVars.DealerContextByKuserId !== undefined
            ? stateVars.DealerContextByKuserId?.length > 0
              ? stateVars.DealerContextByKuserId[0].id
              : null
            : this.state.DealerContextByKuserId?.length > 0
            ? this.state.DealerContextByKuserId[0].id
            : null
        )
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp674625Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.DealerContextByKuserId !== undefined
            ? stateVars.DealerContextByKuserId?.length > 0
              ? stateVars.DealerContextByKuserId[0].id
              : null
            : this.state.DealerContextByKuserId?.length > 0
            ? this.state.DealerContextByKuserId[0].id
            : null
        ),
        ReactSystemFunctions.toGuid(
          this,
          stateVars.IssuesById !== undefined
            ? stateVars.IssuesById?.length > 0
              ? stateVars.IssuesById[0].assignedTo
              : null
            : this.state.IssuesById?.length > 0
            ? this.state.IssuesById[0].assignedTo
            : null
        )
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp913467Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.IssuesById !== undefined
            ? stateVars.IssuesById?.length > 0
              ? stateVars.IssuesById[0].externalLink
              : null
            : this.state.IssuesById?.length > 0
            ? this.state.IssuesById[0].externalLink
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.IssueDocumentsByIssueId = result?.data.issueDocumentsByIssueId;

    stateVars.SelectIssueMessagesForChat =
      result?.data.selectIssueMessagesForChat;

    formVars.talepdetay_623970_currentusername = ReactSystemFunctions.toString(
      this,
      stateVars.DealerContextByKuserId !== undefined
        ? stateVars.DealerContextByKuserId?.length > 0
          ? stateVars.DealerContextByKuserId[0].id
          : null
        : this.state.DealerContextByKuserId?.length > 0
        ? this.state.DealerContextByKuserId[0].id
        : null
    );
    stateVars.UpdateIssueMessagesIsRead =
      result?.data.updateIssueMessagesIsRead;
    stateVars.SelectIssueImages = result?.data.selectIssueImages;

    stateVars.IssueDocumentsCount = result?.data.issueDocumentsCount;
    formVars.talepdetay_468112_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssueDocumentsCount !== undefined
        ? stateVars.IssueDocumentsCount?.length > 0
          ? stateVars.IssueDocumentsCount[0].issueDocumentCountWithbrackets
          : null
        : this.state.IssueDocumentsCount?.length > 0
        ? this.state.IssueDocumentsCount[0].issueDocumentCountWithbrackets
        : null
    );
    stateVars.IssuesImageCount = result?.data.issuesImageCount;
    formVars.talepdetay_681848_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesImageCount !== undefined
        ? stateVars.IssuesImageCount?.length > 0
          ? stateVars.IssuesImageCount[0].imageCountWithBracket
          : null
        : this.state.IssuesImageCount?.length > 0
        ? this.state.IssuesImageCount[0].imageCountWithBracket
        : null
    );
    stateVars.IsReadUpdate = result?.data.isReadUpdate;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TalepDetayPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TalepDetayPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.talepdetay_426509_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].imageURL
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].imageURL
        : null
    );

    formVars.talepdetay_536259_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].statuString
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].statuString
        : null
    );

    stateVars.isComp536259Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.IssuesById !== undefined
            ? stateVars.IssuesById?.length > 0
              ? stateVars.IssuesById[0].assignedTo
              : null
            : this.state.IssuesById?.length > 0
            ? this.state.IssuesById[0].assignedTo
            : null
        ),
        ReactSystemFunctions.toString(
          this,
          stateVars.DealerContextByKuserId !== undefined
            ? stateVars.DealerContextByKuserId?.length > 0
              ? stateVars.DealerContextByKuserId[0].id
              : null
            : this.state.DealerContextByKuserId?.length > 0
            ? this.state.DealerContextByKuserId[0].id
            : null
        )
      ) === true
        ? "visible"
        : "hidden";
    formVars.talepdetay_674625_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].status
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].status
        : null
    );

    stateVars.isComp674625Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.DealerContextByKuserId !== undefined
            ? stateVars.DealerContextByKuserId?.length > 0
              ? stateVars.DealerContextByKuserId[0].id
              : null
            : this.state.DealerContextByKuserId?.length > 0
            ? this.state.DealerContextByKuserId[0].id
            : null
        ),
        ReactSystemFunctions.toGuid(
          this,
          stateVars.IssuesById !== undefined
            ? stateVars.IssuesById?.length > 0
              ? stateVars.IssuesById[0].assignedTo
              : null
            : this.state.IssuesById?.length > 0
            ? this.state.IssuesById[0].assignedTo
            : null
        )
      ) === true
        ? "visible"
        : "hidden";
    formVars.talepdetay_630431_value = ReactSystemFunctions.value(
      this,
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].createdAt
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].createdAt
        : null
    );

    formVars.talepdetay_11419_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].title
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].title
        : null
    );

    formVars.talepdetay_583778_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].content
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].content
        : null
    );

    formVars.talepdetay_913467_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].externalLink
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].externalLink
        : null
    );

    stateVars.isComp913467Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.IssuesById !== undefined
            ? stateVars.IssuesById?.length > 0
              ? stateVars.IssuesById[0].externalLink
              : null
            : this.state.IssuesById?.length > 0
            ? this.state.IssuesById[0].externalLink
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.talepdetay_468112_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssueDocumentsCount !== undefined
        ? stateVars.IssueDocumentsCount?.length > 0
          ? stateVars.IssueDocumentsCount[0].issueDocumentCountWithbrackets
          : null
        : this.state.IssueDocumentsCount?.length > 0
        ? this.state.IssueDocumentsCount[0].issueDocumentCountWithbrackets
        : null
    );

    stateVars.dataSource_62971 =
      stateVars.IssueDocumentsByIssueId ?? this.state.IssueDocumentsByIssueId;
    formVars.talepdetay_681848_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesImageCount !== undefined
        ? stateVars.IssuesImageCount?.length > 0
          ? stateVars.IssuesImageCount[0].imageCountWithBracket
          : null
        : this.state.IssuesImageCount?.length > 0
        ? this.state.IssuesImageCount[0].imageCountWithBracket
        : null
    );

    stateVars.dataSource_924396 =
      stateVars.SelectIssueImages ?? this.state.SelectIssueImages;

    formVars.talepdetay_623970_currentUsername = ReactSystemFunctions.toString(
      this,
      stateVars.DealerContextByKuserId !== undefined
        ? stateVars.DealerContextByKuserId?.length > 0
          ? stateVars.DealerContextByKuserId[0].id
          : null
        : this.state.DealerContextByKuserId?.length > 0
        ? this.state.DealerContextByKuserId[0].id
        : null
    );

    stateVars.dataSource_623970 =
      stateVars.SelectIssueMessagesForChat ??
      this.state.SelectIssueMessagesForChat;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  TalepDetayComponent_980674_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TalepDetayComponent_225408_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TalepDetayComponent_674625_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Status_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "talepdetay_674625_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TalepDetay/TalepDetayComponent_674625_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.IssueStatuUpdate = result?.data.issueStatuUpdate;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  TalepDetayComponent_913467_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.OpenInBrowser = await ReactSystemFunctions.openInBrowser(
      ReactSystemFunctions.toString(
        this,
        stateVars.IssuesById !== undefined
          ? stateVars.IssuesById?.length > 0
            ? stateVars.IssuesById[0].externalLink
            : null
          : this.state.IssuesById?.length > 0
          ? this.state.IssuesById[0].externalLink
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TalepDetayComponent_673189_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "TalepBelgeForm",
      "Id",
      ReactSystemFunctions.convertToTypeByName(Guid.create().toString(), "Guid")
    );
    KuikaAppManager.addToPageInputVariables(
      "TalepBelgeForm",
      "IssueID",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "TalepDetay",
      "TalepBelgeForm",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TalepDetayComponent_198191_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp113390Visible",
          "string"
        )
      );
    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp198191Visible",
          "string"
        )
      );
    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName("isComp24762Visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TalepDetayComponent_24762_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp113390Visible",
          "string"
        )
      );
    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp198191Visible",
          "string"
        )
      );
    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName("isComp24762Visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TalepDetayComponent_219557_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "talepdetay_62971_value", "id"),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TalepDetay/TalepDetayComponent_219557_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectIssuesDocumentsBase64ById =
      result?.data.selectIssuesDocumentsBase64ById;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TalepDetayComponent_219557_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TalepDetayComponent_219557_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.DownloadFile = await ReactSystemFunctions.downloadFile(
      ReactSystemFunctions.toString(
        this,
        stateVars.SelectIssuesDocumentsBase64ById !== undefined
          ? stateVars.SelectIssuesDocumentsBase64ById?.length > 0
            ? stateVars.SelectIssuesDocumentsBase64ById[0].documanBase64
            : null
          : this.state.SelectIssuesDocumentsBase64ById?.length > 0
          ? this.state.SelectIssuesDocumentsBase64ById[0].documanBase64
          : null
      ),
      ReactSystemFunctions.value(this, "talepdetay_62971_value", "docName")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TalepDetayComponent_99344_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.isWeb = await ReactSystemFunctions.isWeb();

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TalepDetayComponent_99344_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TalepDetayComponent_99344_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "FotoDrawer",
      "sessionName",
      ReactSystemFunctions.convertToTypeByName("IssuePhoto", "string")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.TalepDetayComponent_99344_onClick_if11_,
      "TalepDetay",
      "FotoDrawer",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "902998",
      null,
      null,
      "true",
      "350px",
      "250px",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  TalepDetayComponent_99344_onClick_if11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("IssuePhoto", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TalepDetayComponent_99344_onClick_if12_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TalepDetayComponent_99344_onClick_if12_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      IssueId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
      ImageId_0: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
      ImageBase64_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TalepDetay/TalepDetayComponent_99344_onClick_if12_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.IssuesImageSave = result?.data.issuesImageSave;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  TalepDetayComponent_99344_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "FotoDrawer",
      "sessionName",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("IssuePhoto", "string"),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.TalepDetayComponent_99344_onClick_else11_,
      "TalepDetay",
      "FotoDrawer",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "916026",
      null,
      "right",
      "true",
      "100vw",
      "40vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  TalepDetayComponent_99344_onClick_else11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("IssuePhoto", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TalepDetayComponent_99344_onClick_else12_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TalepDetayComponent_99344_onClick_else12_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      IssueId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
      ImageId_0: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
      ImageBase64_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TalepDetay/TalepDetayComponent_99344_onClick_else12_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.IssuesImageSave = result?.data.issuesImageSave;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  TalepDetayComponent_99344_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.isWeb),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      isErrorOccurred = await this.TalepDetayComponent_99344_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.TalepDetayComponent_99344_onClick_else1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TalepDetayComponent_99344_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TalepDetayComponent_99344_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      IssuesId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TalepDetay/TalepDetayComponent_99344_onClick2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectIssueImages = result?.data.selectIssueImages;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TalepDetayComponent_99344_onClick3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TalepDetayComponent_99344_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_924396 =
      stateVars.SelectIssueImages ?? this.state.SelectIssueImages;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TalepDetayComponent_16524_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp287898Visible",
          "string"
        )
      );
    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName("isComp16524Visible", "string")
      );
    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp971495Visible",
          "string"
        )
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TalepDetayComponent_971495_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp287898Visible",
          "string"
        )
      );
    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName("isComp16524Visible", "string")
      );
    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp971495Visible",
          "string"
        )
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TalepDetayComponent_623970_onMessageSend = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      IssueID_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
      MessageText_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "talepdetay_623970_value",
            "message",
            "SelectIssueMessagesForChat",
            "",
            ""
          )
        ),
        "string"
      ),
      SenderId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.DealerContextByKuserId !== undefined
            ? stateVars.DealerContextByKuserId?.length > 0
              ? stateVars.DealerContextByKuserId[0].id
              : null
            : this.state.DealerContextByKuserId?.length > 0
            ? this.state.DealerContextByKuserId[0].id
            : null
        ),
        "Guid"
      ),
      IssueID_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TalepDetay/TalepDetayComponent_623970_onMessageSend",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.IssueMessagesSave = result?.data.issueMessagesSave;
    stateVars.SelectIssueMessagesForChat =
      result?.data.selectIssueMessagesForChat;

    formVars.talepdetay_623970_currentusername = ReactSystemFunctions.toString(
      this,
      stateVars.DealerContextByKuserId !== undefined
        ? stateVars.DealerContextByKuserId?.length > 0
          ? stateVars.DealerContextByKuserId[0].id
          : null
        : this.state.DealerContextByKuserId?.length > 0
        ? this.state.DealerContextByKuserId[0].id
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TalepDetayComponent_623970_onMessageSend1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TalepDetayComponent_623970_onMessageSend1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_623970 =
      stateVars.SelectIssueMessagesForChat ??
      this.state.SelectIssueMessagesForChat;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, 902998, 916026] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.TalepDetayPageInit();
    }
    if (diId == 902998) {
      isErrorOccurred = await this.TalepDetayComponent_99344_onClick_if11_();
      if (isErrorOccurred) return true;
    } else if (diId == 916026) {
      isErrorOccurred = await this.TalepDetayComponent_99344_onClick_else11_();
      if (isErrorOccurred) return true;
    }
  }
}
